export default {
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/mixins/positionable.js
// module id = 5a0n
// module chunks = 0